import React from 'react';
import { useQuery } from '@apollo/client';
import { Card } from 'quanta-ui';
import {
  SEARCH_CUSTOMER_BY_NUMBER,
  INTERMEDIARY_LIST,
  VIEW_POLICY_FIRE,
  GET_DEFAULT_WARRANTIES,
  GET_DEFAULT_CLAUSES,
  GET_DEFAULT_CONDITIONS,
  GET_DEFAULT_EXCLUSIONS,
  VIEW_PROPOSAL_FIRESF
} from './queries';
import { Loading,Error } from 'quanta-flows/modules/layout';
import ViewPolicyDetailsFire from './policy-details-fire/index';

export default function PolicyDetailsPanelFire({
  proposal_no,
  policy_no,
  customer_id,
  lobProductList,
  forwardedCoversFormRef,
}) {
  let { loading, error, data } = useQuery(VIEW_PROPOSAL_FIRESF, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        proposalNumber: proposal_no,
        customerID: customer_id,
        productCode: "1132"
      },
    },
  });

  let {
    loading: loadingCustomer,
    error: errorCustomer,
    data: customerData,
  } = useQuery(SEARCH_CUSTOMER_BY_NUMBER, {
    variables: {
      input: {
        customer_number: customer_id,
      },
    },
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);

  const {
    loading: loadingDefaultWarranties,
    error: errorDefaultWarranties,
    data: dataDefaultWarranties,
  } = useQuery(GET_DEFAULT_WARRANTIES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode: '1131',
        populateType: '4',
      },
    },
  });

  const {
    loading: loadingDefaultClauses,
    error: errorDefaultClauses,
    data: dataDefaultClauses,
  } = useQuery(GET_DEFAULT_CLAUSES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode: '1131',
        populateType: '1',
      },
    },
  });

  const {
    loading: loadingDefaultConditions,
    error: errorDefaultConditions,
    data: dataDefaultConditions,
  } = useQuery(GET_DEFAULT_CONDITIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode: '1131',
        populateType: '2',
      },
    },
  });

  const {
    loading: loadingDefaultExclusions,
    error: errorDefaultExclusions,
    data: dataDefaultExclusions,
  } = useQuery(GET_DEFAULT_EXCLUSIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode: '1131',
        populateType: '3',
      },
    },
  });

  if (
    loading ||
    loadingCustomer ||
    loadingMyIntermediaries ||
    loadingDefaultWarranties ||
    loadingDefaultClauses ||
    loadingDefaultConditions ||
    loadingDefaultExclusions
  ) {
    return (
      <Card className="h-screen">
        <Loading />
      </Card>
    );
  }

  if (
    error ||
    errorCustomer ||
    errorMyIntermediaries ||
    errorDefaultWarranties ||
    errorDefaultClauses ||
    errorDefaultConditions ||
    errorDefaultExclusions
  ) {
    return (
      <Card className="h-screen">
        <Error
          {...{
            error:
              error ||
              errorCustomer ||
              errorMyIntermediaries ||
              errorDefaultWarranties ||
              errorDefaultClauses ||
              errorDefaultConditions ||
              errorDefaultExclusions,
          }}
        />
      </Card>
    );
  }

  let { customer } = customerData;
  let { viewProposalSF } = data;
  let { myIntermediaries } = dataMyIntermediaries;
  let { getDefaultWarranties } = dataDefaultWarranties;
  let { getDefaultClauses } = dataDefaultClauses;
  let { getDefaultConditions } = dataDefaultConditions;
  let { getDefaultExclusions } = dataDefaultExclusions;

  return (
    <>
      <ViewPolicyDetailsFire
        forwardedCoversFormRef={forwardedCoversFormRef}
        viewProposalSF={viewProposalSF}
        customer={customer}
        policy_no={policy_no}
        customer_id={customer_id}
        proposal_no={proposal_no}
        lobProductList={lobProductList}
        myIntermediaries={myIntermediaries}
        getDefaultWarranties={getDefaultWarranties}
        getDefaultClauses={getDefaultClauses}
        getDefaultConditions={getDefaultConditions}
        getDefaultExclusions={getDefaultExclusions}
      />
    </>
  );
}
